/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Insurance/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Insurance({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Insurance",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#53C549"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Insurance.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-Z2rgixk': alignSelf,'--mt-2-Z2rgixk': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2rgixk': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2rgixk': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2rgixk': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2rgixk': opacity,'--w-10-Z2rgixk': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2rgixk': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2rgixk': fill,'--a-7-Z2rgixk': isAnimated ? animation : "none",'--sd-8-Z2rgixk': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2rgixk': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Insurance.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M7.92 2a.5.5 0 00-.5.5v1.406H6.014a.5.5 0 00-.5.5v1.625a.5.5 0 00.5.5H7.42v1.407a.5.5 0 00.5.5h1.625a.5.5 0 00.5-.5V6.53h1.406a.5.5 0 00.5-.5V4.406a.5.5 0 00-.5-.5h-1.406V2.5a.5.5 0 00-.5-.5H7.92zM10 16v-2.086a1 1 0 01.293-.707l2.168-2.168a.687.687 0 01.921 1.017l-.927.927a.625.625 0 00.883.884l.928-.928a1.937 1.937 0 00-.766-3.21V8.667c0-.92.746-1.667 1.667-1.667.46 0 .833.373.833.833v5.339a2 2 0 01-.586 1.414L14 16h-4zm-2-2.086V16H4l-1.414-1.414A2 2 0 012 13.172V7.833c0-.46.373-.833.833-.833.92 0 1.667.746 1.667 1.667v1.062a1.937 1.937 0 00-.766 3.21l.927.928a.625.625 0 00.884-.884l-.927-.928a.687.687 0 01.921-1.016l2.168 2.168a1 1 0 01.293.707z"
 style={{'--f-12-Z2rgixk': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}